import type { DialogService } from '@patsnap/tahiti-core';
import type { WireFrameExtractDialogOptions, WireFrameExtractDialogResult } from './types';

export interface WireFrameExtractDialogService extends DialogService<WireFrameExtractDialogOptions, WireFrameExtractDialogResult> {
    /**
     * 打开线框提取对话框
     * @param options 对话框选项
     * @returns Promise<WireFrameExtractDialogResult>
     */
    open(options: WireFrameExtractDialogOptions): Promise<WireFrameExtractDialogResult>;
}


export const WireFrameExtractDialogService = Symbol.for('WireFrameExtractDialogService');
